const MOBILE_REGEX = /^1[3-9]\d{9}$/

export const isValidMobile = (value?: string) => {
  if (!value) {
    return false
  }

  return MOBILE_REGEX.test(value)
}
